/* eslint-disable */
import React from 'react';
import 'contents/assets/scss/page/training.scss';
import Upload from '../../component/Inc/Upload';

const EvaluationInterviewRegister = () => {
  return (
    <main className="com_container com_training p_evaluation_interview_register">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_1">
            면접 평가<span className="bar"></span>
            <span className="point_txt">등록하기</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="board_wrap_row">
              <section className="board_wrap">
                <div className="com_info">
                  <p className="name">홍길동103</p>
                  <p className="date dot">2025, 05, 20 11 : 30</p>
                </div>
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="140" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>지점 / 과목</th>
                      <td className="type_row">
                        <div className="com_input_wrap flex_row">
                          <select className="select">
                            <option value="지점 선택">지점 선택</option>
                          </select>
                          <select className="select">
                            <option value="영역 선택">영역 선택</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>나이 / 성별</th>
                      <td>
                        <div className="com_input_wrap flex_row gap">
                          <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
                          <div className="check">
                            <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                            <label htmlFor="rdo_01">남</label>
                            <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                            <label htmlFor="rdo_02">여</label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>거주지</th>
                      <td className="type_row">
                        <div className="com_input_wrap flex_row">
                          <select className="select">
                            <option value="서울">서울</option>
                          </select>
                          <select className="select">
                            <option value="송파구">송파구</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>연락처</th>
                      <td className="type_row">
                        <input type="text" className="input" placeholder="" />
                      </td>
                    </tr>
                    <tr>
                      <th>학력</th>
                      <td className="type_row">
                        <div className="com_input_wrap flex_row">
                          <select className="select">
                            <option value="학교">학교</option>
                          </select>
                          <select className="select">
                            <option value="학과">학과</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>면접 유입경로</th>
                      <td>
                        <div className="radio_wrap">
                          <div className="com_input_wrap flex_row">
                            <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                            <label htmlFor="rdo01">훈장마을</label>
                            <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                            <label htmlFor="rdo02">잡코리아</label>
                            <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                            <label htmlFor="rdo03">알바몬</label>
                          </div>
                          <div className="com_input_wrap flex_row">
                            <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                            <label htmlFor="rdo04">신규</label>
                            <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                            <label htmlFor="rdo05">소개</label>
                            <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                            <label htmlFor="rdo06">재입사</label>
                          </div>
                          <div className="com_input_wrap flex_row gap">
                            <input type="radio" name="rdo" id="rdo07" className="com_chk circle" />
                            <label htmlFor="rdo07">기타</label>
                            <input type="text" className="input ws" />
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th rowSpan={2}>소개자</th>
                      <td>
                        <section className="com_board_search">
                          <article className="search">
                            <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input xs type_search" />
                            <button className="com_btn gray ws xs icon_search"></button>
                          </article>
                        </section>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="com_input_wrap flex_row gap">
                          <span>김교사123</span>
                          <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>수업 방법</th>
                      <td>
                        <input type="checkbox" id="chk01" className="com_chk" />
                        <label htmlFor="chk01">대면</label>
                        <input type="checkbox" id="chk02" className="com_chk" />
                        <label htmlFor="chk02">화상</label>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="140" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>면접 방법 </th>
                      <td>
                        <div className="check">
                          <input type="radio" name="rdo2" id="rdo_03" className="com_chk circle" />
                          <label htmlFor="rdo_03">대면</label>
                          <input type="radio" name="rdo2" id="rdo_04" className="com_chk circle" />
                          <label htmlFor="rdo_04">화상</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>기프트콘 발송여부</th>
                      <td>
                        <div className="com_input_wrap flex_row gap">
                          <input type="radio" name="rdo3" id="rdo_03" className="com_chk circle" />
                          <label htmlFor="rdo_03">Y</label>
                          <div>&</div>
                          <input type="radio" name="rdo3" id="rdo_04" className="com_chk circle" />
                          <label htmlFor="rdo_04">N</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>면접일</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
                          <select className="select edit_width">
                            <option value="선택">선택</option>
                          </select>
                          <select className="select edit_width">
                            <option value="선택">선택</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>파일등록</th>
                      <td>
                        <div className="com_input_upload">
                          <Upload title="파일 등록" className="com_btn gray xs wl" />
                          <p className="file">
                            <span className="txt">File name.pdf</span>
                            <button type="button" className="btn_del_file" onClick={() => {}}></button>
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="140" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>항목</th>
                      <td className="td_table">
                        <table className="com_board_list inner">
                          <colgroup>
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                          </colgroup>
                          <thead>
                            <tr>
                              <th>태도</th>
                              <th>경험</th>
                              <th>사례평가</th>
                              <th>시강(풀이)</th>
                              <th>시강(설명)</th>
                            </tr>
                          </thead>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <th>배점</th>
                      <td className="td_table">
                        <table className="com_board_list inner">
                          <colgroup>
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td className="td_inner">40</td>
                              <td>44</td>
                              <td>16</td>
                              <td>60</td>
                              <td>40</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <th>면접관 가산점수</th>
                      <td>
                        <select className="select">
                          <option value="5점">5점</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>가산 점수 사유</th>
                      <td>
                        <input type="text" className="input" />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="140" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>교육 수료 의지</th>
                      <td>
                        <div className="check">
                          <input type="radio" name="rdo4" id="rdo_05" className="com_chk circle" />
                          <label htmlFor="rdo_05">적극</label>
                          <input type="radio" name="rdo4" id="rdo_06" className="com_chk circle" />
                          <label htmlFor="rdo_06">보통</label>
                          <input type="radio" name="rdo4" id="rdo_07" className="com_chk circle" />
                          <label htmlFor="rdo_07">미흡</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>교육 참석 가능 시기</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
                          <select className="select edit_width">
                            <option value="선택">선택</option>
                          </select>
                          <select className="select edit_width">
                            <option value="선택">선택</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>점수 / 등급</th>
                      <td className="com_blue_txt">158점ㅣC등급ㅣ조건부 합격</td>
                    </tr>
                  </tbody>
                </table>
                <h3 className="detail_tit dot">면접 평가 상세</h3>
                <textarea name="" id="" className="textarea" placeholder="내용 입력"></textarea>
              </section>
              <section className="board_wrap">
                <h3 className="detail_tit dot">면접 평가 상세</h3>
                <div className="notice">
                  * 면접관은 평가의 3대 주의점(관대화, 중심화, 사적감정 개입금지)을 원칙으로 평가. <br />* 기본 2점(보통)을 기준으로 가감산하여 평가.
                </div>
                <table className="com_board_list type_score">
                  <colgroup>
                    <col width="60" />
                    <col width="auto" />
                    <col width="70" />
                    <col width="70" />
                    <col width="70" />
                    <col width="70" />
                    <col width="70" />
                    <col width="70" />
                    <col width="70" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>면접 문항</th>
                      <th>4</th>
                      <th>3</th>
                      <th>2</th>
                      <th>1</th>
                      <th>0</th>
                      <th className="com_blue_txt">배점</th>
                      <th>구분</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td className="td_left">직관 ㅣ 면접시간 준수 여부</td>
                      <td>미리</td>
                      <td>정시</td>
                      <td>시간조정</td>
                      <td className="bg_col">
                        지각
                        <br />
                        사전통보
                      </td>
                      <td>
                        무단 <br />
                        지각
                      </td>
                      <td className="com_blue_txt">4/8</td>
                      <td>경험</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td className="td_left">직관 ㅣ 복장</td>
                      <td className="bg_col">
                        매우 <br />
                        단정
                      </td>
                      <td>단정</td>
                      <td>보통</td>
                      <td>불량</td>
                      <td>
                        매우 <br />
                        불량
                      </td>
                      <td className="com_blue_txt">2/4</td>
                      <td>경험</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td className="td_left">직관 ㅣ 외모</td>
                      <td>
                        매우 <br />
                        호감
                      </td>
                      <td>호감</td>
                      <td>보통</td>
                      <td className="bg_col">
                        약간 <br /> 비호감
                      </td>
                      <td>비호감</td>
                      <td className="com_blue_txt">1/4</td>
                      <td>경험</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td className="td_left">직관 ㅣ 목소리 (웅얼거림, 갈라짐, 너무 큼, 기타)</td>
                      <td>
                        매우 <br />
                        호감
                      </td>
                      <td>호감</td>
                      <td>보통</td>
                      <td className="bg_col">
                        약간 <br /> 비호감
                      </td>
                      <td>비호감</td>
                      <td className="com_blue_txt">2/4</td>
                      <td>경험</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td className="td_left">서류평가 ㅣ 지도과목, 전공적합성</td>
                      <td className="bg_col">
                        동일 <br /> 계열
                      </td>
                      <td>
                        유사 <br /> 계열
                      </td>
                      <td>보통</td>
                      <td>
                        거의 <br /> 무관
                      </td>
                      <td>
                        완전 <br /> 무관
                      </td>
                      <td className="com_blue_txt">3/4</td>
                      <td>태도</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td className="td_left">서류평가 ㅣ 졸업대학 우수성</td>
                      <td>최상위</td>
                      <td>상위</td>
                      <td>중위</td>
                      <td className="bg_col">중하위</td>
                      <td>하위</td>
                      <td className="com_blue_txt">5/4</td>
                      <td>태도</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td className="td_left">
                        학원 지도 경력은 얼마나 되십니까? <br />
                        질문) 원천징수 가능여부, 원장님 성함, 위치/규모(강사수, 학생수)
                      </td>
                      <td className="bg_col">
                        7년 <br />
                        이상
                      </td>
                      <td>
                        5년 <br />
                        이상
                      </td>
                      <td>
                        3년 <br />
                        이상
                      </td>
                      <td>
                        1년 <br />
                        이상
                      </td>
                      <td>없음</td>
                      <td className="com_blue_txt">6/8</td>
                      <td>태도</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td className="td_left">
                        과외 지도 경력은 얼마나 되십니까? <br />
                        질문) 학생/학부모 소통방법, 가장 길게 했던 과외기간
                      </td>
                      <td>
                        7년 <br />
                        이상
                      </td>
                      <td>
                        5년 <br />
                        이상
                      </td>
                      <td className="bg_col">
                        3년 <br />
                        이상
                      </td>
                      <td>
                        1년 <br />
                        이상
                      </td>
                      <td>없음</td>
                      <td className="com_blue_txt">0/8</td>
                      <td>태도</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td className="td_left">
                        선생님께서 맡으실 수 있는 학년은 어떻게 되십니까? <br />
                        질문) 추천교재, 주로 사용 기출문제집(고3)
                      </td>
                      <td>고3</td>
                      <td className="bg_col">고2</td>
                      <td>고1</td>
                      <td>중등</td>
                      <td>초등</td>
                      <td className="com_blue_txt">5/4</td>
                      <td>태도</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td className="td_left">
                        등급 기준으로 선생님께서 안정적으로 지도 가능한 학생의 수준은 어떻게 되십니까? <br />
                        질문) 해당 등급 학생이 제일 어려워 하는 부분 및 보완방법
                      </td>
                      <td>1등급</td>
                      <td className="bg_col">2등급</td>
                      <td>3등급</td>
                      <td>4등급</td>
                      <td>
                        판단 <br />
                        불가
                      </td>
                      <td className="com_blue_txt">0/4</td>
                      <td>태도</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td className="td_left">
                        지도 가능 학생에 맞는 4개월간의 학습로드맵을 세우고 작성할 수 있으신가요? <br />
                        질문) 계획 대략 질문, 학생이 잘 따라오는지 확인(점검) 방법
                      </td>
                      <td>
                        즉시 <br /> 가능
                      </td>
                      <td>가능</td>
                      <td className="bg_col">
                        준비 <br />
                        필요
                      </td>
                      <td>
                        교육 <br />
                        필요
                      </td>
                      <td>모름</td>
                      <td className="com_blue_txt">4/4</td>
                      <td>태도</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td className="td_left">
                        출판사별 내신수업, 수능기출문제, 변형문제, 족보데이터 등의 학년별 수업자료가 얼마나 준비되어 있으신가요?
                        <br /> 질문) 자료 받는 사이트, 직접 제작한 자료 여부 및 설명요구
                      </td>
                      <td className="bg_col">충분히 보유</td>
                      <td>적당히 보유</td>
                      <td>보통</td>
                      <td>
                        약간 <br /> 부족
                      </td>
                      <td>
                        매우 <br />
                        부족
                      </td>
                      <td className="com_blue_txt">0/4</td>
                      <td>태도</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td className="td_left">강사가 부족한 지역은 빠르게 수업을 받으실 수 있습니다. 해당 지역에 수업배정을 받으실 용의가 있으신가요?</td>
                      <td>
                        매우 <br />
                        적절
                      </td>
                      <td className="bg_col">적절</td>
                      <td>보통</td>
                      <td>부적절</td>
                      <td>
                        매우 <br />
                        부적절
                      </td>
                      <td className="com_blue_txt">0/8</td>
                      <td>경험</td>
                    </tr>
                    <tr>
                      <td>14</td>
                      <td className="td_left">학생이 수업 2시간 전 수업시간 변경을 원할 경우, 강사님 개인사정으로 수업 2시간 전 수업시간 변경이 필요할 경우 어떻게 하시겠습니까?</td>
                      <td>
                        매우 <br />
                        적절
                      </td>
                      <td>적절</td>
                      <td>보통</td>
                      <td>부적절</td>
                      <td className="bg_col">
                        매우 <br />
                        부적절
                      </td>
                      <td className="com_blue_txt">0/4</td>
                      <td>경험</td>
                    </tr>
                    <tr>
                      <td>15</td>
                      <td className="td_left">수업 중 학생이 집중을 하지 못할 경우 어떻게 하시겠습니까?</td>
                      <td className="bg_col">
                        매우 <br />
                        적절
                      </td>
                      <td>적절</td>
                      <td>보통</td>
                      <td>부적절</td>
                      <td>
                        매우 <br />
                        부적절
                      </td>
                      <td className="com_blue_txt">0/4</td>
                      <td>태도</td>
                    </tr>
                    <tr>
                      <td>16</td>
                      <td className="td_left">채용 후 본사에 진행하는 교육에 참여하셔야 배정이 가능 합니다. 참석 가능하시겠습니까? 질문) 교육은 언제부터 참석 가능시기(날짜) 확인</td>
                      <td>
                        매우 <br />
                        적절
                      </td>
                      <td className="bg_col">적절</td>
                      <td>보통</td>
                      <td>부적절</td>
                      <td>
                        매우 <br />
                        부적절
                      </td>
                      <td className="com_blue_txt">0/8</td>
                      <td>경험</td>
                    </tr>
                  </tbody>
                </table>
                <div className="total_score">
                  <strong>54</strong>/<span>84</span>
                </div>
                <h3 className="detail_tit dot">사례평가 (서면평가)</h3>
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="140" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>점수 등록(16점)</th>
                      <td>
                        <input className="input com_blue_txt ws" type="text" defaultValue={12} />
                      </td>
                    </tr>
                    <tr>
                      <th>시험지 등록</th>
                      <td>
                        <div className="com_input_upload">
                          <Upload title="파일 등록" className="com_btn gray xs wl" />
                          <p className="file">
                            <span className="txt">File name.pdf</span>
                            <button type="button" className="btn_del_file" onClick={() => {}}></button>
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>평가 내용</th>
                      <td>
                        <input className="input" type="text" />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h3 className="detail_tit dot">시강 풀이 (서면평가)</h3>
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="140" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>시강지 유형</th>
                      <td>
                        <div className="check">
                          <input type="radio" name="rdo_5" id="rdo_08" className="com_chk circle" />
                          <label htmlFor="rdo_08">고3이상(대문자)</label>
                          <input type="radio" name="rdo_5" id="rdo_09" className="com_chk circle" />
                          <label htmlFor="rdo_09">고2이하(소문자)</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>점수 등록(16점)</th>
                      <td>
                        <input className="input com_blue_txt ws" type="text" defaultValue={12} />
                      </td>
                    </tr>
                    <tr>
                      <th>시험지 등록</th>
                      <td>
                        <div className="com_input_upload">
                          <Upload title="파일 등록" className="com_btn gray xs wl" />
                          <p className="file">
                            <span className="txt">File name.pdf</span>
                            <button type="button" className="btn_del_file" onClick={() => {}}></button>
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>평가 내용</th>
                      <td>
                        <input className="input" type="text" />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h3 className="detail_tit dot">시강 설명 (대면평가)</h3>
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="140" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>점수 등록(16점)</th>
                      <td>
                        <input className="input com_blue_txt ws" type="text" defaultValue={12} />
                      </td>
                    </tr>
                    <tr>
                      <th>평가 내용</th>
                      <td>
                        <input className="input" type="text" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </section>

          <section className="box full">
            <div className="com_btn_wrap center">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default EvaluationInterviewRegister;
